<template>
  <div class="forms-view">
    <p>Müşteri Hizmetleri süreçlerimizde kullanabileceğiniz formları, aşağıdaki listede bulabilirsiniz.</p>
    <b-modal
    title="Cihaz Gönderim Formu"
    :hide-footer="true"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    id="end-user-service-form"><EndUserServiceForm />
    </b-modal>    

    <b-card>
      <b-table :fields="fields" :items="forms" caption-top>
        <template #table-caption>Form Listesi</template>
        <template #head(source)="">
          <v-icon name="cloud"/>
        </template>
        <template #cell(source)="data">
          <a v-if="data.value.isFile" class="download-link" target="_blank" :href="data.value.target"><v-icon name="angle-double-down"/></a>
          <a v-else class="download-link" target="_blank" href="#" v-on:click.prevent="$bvModal.show(data.value.target)"><v-icon name="edit"/></a>
        </template>

      </b-table>
    </b-card>
  </div>
</template>

<script>

import EndUserServiceForm from './EndUserServiceForm.vue'

export default {
  name: 'FormsView',
  components: {
    EndUserServiceForm
  },
  data() {
    return {
      fields: [
        { key: 'department', label: 'Departman'},
        { key: 'topic', label: 'Konu'},
        { key: 'source', label: 'Dosya', class: 'text-center'}
      ],
      forms: [
        { department: 'Teknik Servis', topic: 'Cihaz Gönderim Formu (Online)', source: { isFile: false, target: 'end-user-service-form'} },
        { department: 'Teknik Servis', topic: 'Cihaz Gönderim Formu', source: { isFile: true, target: 'files/technical-service/cihaz-gonderim-formu.pdf'} }
      ]
    }
  },
  async mounted() {
    const params = new Proxy(
      new URLSearchParams(window.location.search), 
      {
        get: (searchParams, prop) => searchParams.get(prop),
      }
    );

    if(params.sirketSMS)
    {
      this.$bvModal.show('end-user-service-form');
    }
  }
}
</script>

<style scoped>
  .download-link { color: #000; }
  .download-link:hover { color: #ED9D25; }
</style>